import isBrowser from '@/utils/is-browser';
import { LatLngTuple, Marker as LeafletMarker } from 'leaflet';
import React, { CSSProperties } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import FocusMarkerHandler from './focus-marker-handler';
import icon from './icon-marker';
import OpenPopupHandler from './open-popup-handler';

export interface MapMarker {
  position: LatLngTuple;
  text: JSX.Element | string;
}

export interface MapProps {
  height?: CSSProperties['height'];
  markers?: MapMarker[];
  focusFunctions?: [number, React.Dispatch<React.SetStateAction<number>>];
  markerIndexToFocus?: number;
}

const Map: React.FunctionComponent<MapProps> = ({
  height = `500px`,
  markers,
}) => {
  const markerRefs: LeafletMarker[] = [];

  if (!isBrowser) return null;
  return (
    <MapContainer
      center={[50.8503396, 4.3517103]}
      zoom={8}
      scrollWheelZoom={false}
      style={{ height }}
    >
      <FocusMarkerHandler markers={markers} />
      <OpenPopupHandler markerRefs={markerRefs} />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {markers?.map((marker, index) => (
        <Marker
          position={marker.position}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          icon={icon}
          ref={(ref) => {
            markerRefs[index] = ref;
          }}
        >
          <Popup>{marker.text}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};
export default Map;
